var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCtaBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 645,
    viewBox: "0 0 1920 645",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1245.88,
    y: 103.824,
    width: 564,
    height: 1357.65,
    rx: 282,
    transform: "rotate(39.7593 1245.88 103.824)",
    fill: "url(#paint1_linear_132_852)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 771.188,
    y: 642.918,
    width: 564,
    height: 1357.65,
    rx: 282,
    transform: "rotate(-136.875 771.188 642.918)",
    fill: "url(#paint2_linear_132_852)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_132_852",
    x1: 1479.78,
    y1: 136.174,
    x2: 1642.15,
    y2: 750.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5368DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A44680"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_132_852",
    x1: 1005.09,
    y1: 675.268,
    x2: 1167.46,
    y2: 1289.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5368DE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_132_852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 644,
    fill: "white",
    transform: "translate(0 0.289062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaBg);
export default __webpack_public_path__ + "static/media/cta-bg.a6cb683317c8ff4d4faa5c549cd1a8f9.svg";
export { ForwardRef as ReactComponent };